import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punecabfare() {



const cardData = {
  keyword: "Pune Cab Fare",
  heading: "Lotus Cab: Pune Cab Fare & Charges Details",

  headingDescription:
    "Lotus Cab provides transparent and affordable Pune Cab Fare services for local, airport, and outstation travel. We offer clear per kilometer pricing with no hidden charges, ensuring complete fare transparency before booking confirmation. Whether you need a sedan for city travel, an SUV for family trips, or an airport drop taxi, our pricing structure remains competitive and straightforward. Night charges, driver allowance, toll, and waiting policies are explained clearly in advance. With flexible ride options and professional drivers, Lotus Cab ensures cost-effective, safe, and reliable travel across Pune and beyond.",

  top: "Popular Cab Fare Categories in Pune",

  topPlaces: [
    {
      title: "Pune Local Taxi Fare",
      description:
        "Pune local taxi fare is calculated based on hourly or per kilometer packages depending on travel needs. It is ideal for city rides, meetings, shopping trips, and daily travel. Our local packages offer flexible 4-hour and 8-hour booking options. AC sedans and SUVs are available with transparent billing. No surge pricing is applied. Customers receive affordable and predictable pricing for city travel."
    },
    {
      title: "Pune Airport Cab Fare",
      description:
        "Pune airport cab fare depends on pickup location and vehicle type selected. We provide fixed and transparent airport transfer pricing. On-time pickup and drop services are ensured. Early morning and late-night airport transfers are available. Professional drivers track flight schedules for timely service. Affordable airport taxi options are offered without hidden charges."
    },
    {
      title: "Pune Outstation Cab Fare",
      description:
        "Outstation cab fare from Pune is calculated on a per kilometer basis with minimum distance criteria. It includes flexible one-way and round-trip options. Toll, parking, and driver allowance details are shared clearly before booking. Long-distance routes are handled by experienced drivers. Sedan and SUV options are available. Competitive pricing makes outstation travel budget-friendly."
    },
    {
      title: "Pune AC Cab Fare",
      description:
        "AC cab fare in Pune includes fully air-conditioned sedan and SUV vehicles. Cooling comfort is maintained throughout the ride. AC usage does not attract additional hidden charges. Ideal for summer travel and long-distance journeys. Vehicles are clean and well-maintained. Affordable pricing ensures comfortable travel within budget."
    },
    {
      title: "Pune SUV Cab Fare",
      description:
        "SUV cab fare in Pune is suitable for group and family travel. Larger vehicles provide extra seating and luggage space. Ideal for outstation trips and airport transfers. Pricing is shared transparently based on distance and duration. Comfortable ride quality ensures long journey convenience. Affordable SUV packages are available for multiple travel needs."
    },
    {
      title: "Pune Night Cab Charges",
      description:
        "Night cab charges in Pune are applied as per standard timing policies. Fare details are shared before ride confirmation. Safe and secure night travel is ensured. Drivers are trained for late-night operations. Airport and outstation trips are available 24/7. Transparent night pricing avoids billing confusion."
    },
    {
      title: "Pune Corporate Cab Charges",
      description:
        "Corporate cab charges in Pune are structured for business and office travel requirements. Monthly and contract-based pricing options are available. Professional chauffeurs ensure punctual pickups. Ideal for employee transport and meetings. Clean vehicles maintain executive standards. Affordable corporate packages are provided with full billing transparency."
    },
    {
      title: "Pune Family Trip Cab Fare",
      description:
        "Family trip cab fare in Pune depends on travel duration and destination. SUVs and spacious sedans are recommended for comfort. Long-distance pricing is calculated per km. Safety and smooth driving are ensured. Flexible return scheduling options are available. Affordable family packages make travel stress-free."
    }
  ],

  services: [
    {
      name: "Pune Cab Charges Per Km",
      description:
        "Pune cab charges per km are calculated transparently based on vehicle category and travel type. Sedan and SUV pricing differs slightly depending on comfort level and fuel type. Customers receive fare estimation before confirmation. No hidden surge pricing is applied. Per kilometer billing ensures fair cost calculation. Affordable pricing structure benefits both local and outstation travelers."
    },
    {
      name: "Pune Drop Taxi Charges",
      description:
        "Pune drop taxi charges apply mainly to one-way travel services. Customers pay only for the single-side distance covered. Ideal for airport transfers and city-to-city drops. Transparent fare breakdown is shared before booking. Toll and driver allowance details are clarified. Budget-friendly drop services ensure cost savings."
    },
    {
      name: "Pune Round Trip Fare",
      description:
        "Round trip fare in Pune is calculated with minimum daily running distance criteria. Ideal for weekend tours and outstation visits. Customers can customize return timing as needed. Vehicle waiting coordination is handled professionally. Transparent billing avoids confusion. Flexible scheduling makes round trips convenient."
    },
    {
      name: "Affordable Cab Fare Pune",
      description:
        "Affordable cab fare in Pune ensures budget-friendly travel without compromising comfort. Clean vehicles and professional drivers are included. Transparent pricing builds customer trust. No hidden charges are added post-ride. Ideal for daily commuters and family travel. Cost-effective packages suit every travel requirement."
    },
    {
      name: "Cheap Taxi Fare Pune",
      description:
        "Cheap taxi fare in Pune is designed for customers seeking economical transport options. Budget sedan vehicles are available. Fare estimation is shared in advance. Quality and safety standards remain uncompromised. Reliable service ensures timely pickup and drop. Affordable pricing makes travel accessible for all."
    },
    {
      name: "Pune Cab Rate List",
      description:
        "Our Pune cab rate list includes clear pricing for local, airport, and outstation travel. Rates are categorized by sedan and SUV vehicle types. Minimum km criteria and waiting charges are explained clearly. Corporate and family packages are included. Transparent rate listing avoids confusion. Customers can plan travel confidently."
    }
  ],

  tableData: [
    ["Pune Cab Fare", "Pune Cab Charges Per Km"],
    ["Pune Local Taxi Fare", "Pune Outstation Cab Fare"],
    ["Pune Airport Cab Fare", "Pune Drop Taxi Charges"],
    ["Pune Round Trip Fare", "Pune AC Cab Fare"],
    ["Pune SUV Fare", "Pune Cab Rate List"],
    ["Affordable Cab Fare Pune", "Cheap Taxi Fare Pune"],
    ["Pune Night Cab Charges", "Pune Family Trip Cab Fare"],
    ["Pune Corporate Cab Charges", ""]
  ],

  whychoose: [
    {
      WhyChooseheading: "Transparent Fare Structure",
      WhyChoosedescription:
        "We provide clear and upfront fare estimation before booking confirmation. Customers are informed about per km charges and additional costs. No hidden fees are added later. Transparent billing builds trust. Every ride follows a structured pricing policy. Customers travel with complete financial clarity."
    },
    {
      WhyChooseheading: "Competitive Pricing Options",
      WhyChoosedescription:
        "Our cab fare in Pune remains competitive compared to market rates. Affordable sedan and SUV options are available. Budget travelers and corporate clients both benefit. Flexible packages suit different needs. Long-distance pricing is economical. Quality service is delivered at reasonable cost."
    },
    {
      WhyChooseheading: "No Hidden Charges",
      WhyChoosedescription:
        "All charges including toll, parking, and driver allowance are explained clearly. Night charges are shared before ride confirmation. Billing remains fully transparent. No surprise pricing after trip completion. Customers receive detailed breakdown. Honest pricing remains our commitment."
    },
    {
      WhyChooseheading: "Multiple Vehicle Categories",
      WhyChoosedescription:
        "We offer sedan, SUV, and premium vehicle options. Pricing varies according to vehicle category selected. Customers can choose according to comfort and budget. Clean and maintained fleet ensures safe travel. Flexible booking options are available. Every vehicle meets service quality standards."
    },
    {
      WhyChooseheading: "24/7 Fare Support",
      WhyChoosedescription:
        "Our team provides fare clarification anytime. Customers can inquire about rate details via call or WhatsApp. Immediate response ensures booking confidence. Transparent communication builds reliability. Support remains active round the clock. Travel planning becomes easier."
    },
    {
      WhyChooseheading: "Fair Night Pricing",
      WhyChoosedescription:
        "Night cab charges are structured fairly. Clear timing policies are followed. Safe night travel is ensured. Drivers are trained for late-night operations. Transparent pricing avoids confusion. Reliable service remains available 24/7."
    },
    {
      WhyChooseheading: "Ideal for Family and Corporate Travel",
      WhyChoosedescription:
        "Flexible fare packages suit both family trips and corporate bookings. Monthly billing options are available. Executive travel is handled professionally. Safe and punctual service is guaranteed. Comfortable vehicles enhance ride experience. Transparent pricing benefits businesses."
    },
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription:
        "Professional drivers ensure safe travel. Vehicles undergo regular servicing. On-time pickup is guaranteed. Transparent fare builds customer loyalty. Clean interiors enhance comfort. Consistent quality service defines our brand."
    }
  ]
};

const faqData = [
  {
    question: "How is Pune cab fare calculated?",
    answer:
      "Pune cab fare is calculated based on per kilometer rates and minimum distance criteria. Vehicle category affects pricing slightly. Toll and parking are additional if applicable. Fare estimation is shared before confirmation. Transparent billing ensures no confusion."
  },
  {
    question: "Are night charges applicable in Pune?",
    answer:
      "Yes, night charges apply as per standard time policy. The timing and rate are clearly explained. No hidden night surcharge is added later. Safe late-night travel is ensured. Transparent pricing is maintained."
  },
  {
    question: "What is the difference between sedan and SUV fare?",
    answer:
      "Sedan fare is generally lower compared to SUV. SUVs provide extra seating and luggage space. Pricing depends on vehicle type selected. Long-distance comfort differs slightly. Customers choose according to budget and requirement."
  },
  {
    question: "Is airport cab fare fixed?",
    answer:
      "Airport cab fare may be fixed or calculated per km depending on location. Transparent pricing is shared before booking. Flight tracking ensures punctuality. No hidden charges apply. Affordable airport transfers are available."
  },
  {
    question: "Do you provide fare estimation before booking?",
    answer:
      "Yes, complete fare estimation is provided before confirmation. Customers receive clear rate breakdown. Toll and driver allowance are explained. Transparent pricing policy is followed. Booking remains hassle-free."
  },
  {
    question: "Are corporate fare packages available?",
    answer:
      "Yes, corporate fare packages are available for business travel. Monthly billing and contract options are offered. Professional drivers ensure punctuality. Clean vehicles maintain executive standards. Affordable corporate rates are provided."
  },
  {
    question: "Is outstation fare different from local fare?",
    answer:
      "Yes, outstation fare is calculated per km with minimum daily running criteria. Local fare is hourly or city-based. Clear fare difference is explained. Transparent billing avoids confusion. Affordable pricing options are available."
  },
  {
    question: "Are toll and parking included?",
    answer:
      "Toll and parking are generally extra unless specified. Fare breakdown is shared clearly. No hidden cost is added later. Transparent billing is maintained. Customers are informed before travel."
  },
  {
    question: "Do AC charges apply separately?",
    answer:
      "No separate AC charge is applied for AC cab bookings. Cooling comfort is included in fare. Transparent pricing is followed. Clean and maintained vehicles ensure comfort. Affordable travel remains priority."
  },
  {
    question: "How can I check the Pune cab rate list?",
    answer:
      "You can contact us via call or WhatsApp for updated rate list. Fare details are shared instantly. Vehicle category pricing is explained clearly. Transparent communication ensures clarity. Booking becomes easier and faster."
  }
];



const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback: "I regularly use Lotus Cab for local and airport travel in Pune. Their cab fare structure is very transparent and clearly explained before booking. There were no hidden charges after the ride. The vehicle was clean and the driver was punctual. I appreciate their professional service and fair pricing. Highly recommended for reliable Pune cab fare services.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "We booked a family SUV for a weekend trip and found the Pune cab fare very reasonable. The pricing was shared clearly in advance including toll details. The driver was polite and drove safely throughout the journey. The vehicle was spacious and comfortable. Overall experience was smooth and stress-free. I would definitely book again.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Rahul Patil",
    feedback: "As a corporate traveler, I look for transparent billing and punctual service. Lotus Cab provided both. Their Pune cab charges per km were competitive and clearly communicated. The car arrived on time and the driver was professional. No last-minute surprises in billing. Very dependable service for business travel.",
    rating: 5
  }
];

















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Cab Fare",
  "image": "https://lotuscab.com/assets/images/pune-cab-fare.jpg", 
  "description": "Lotus Cab provides detailed Pune cab fare information including per km charges, local, outstation, airport, AC, SUV, round trip, and corporate cab fares. Get affordable and transparent taxi pricing for all types of journeys in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5600"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-cab-fare"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune Cab Fare | Lotus Cab</title>
  <meta 
    name="description" 
    content="Check Pune cab fare with Lotus Cab. Get per km rates, local, outstation, airport, AC & SUV taxi charges for corporate, family & night trips. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune Cab Fare, Pune Cab Charges Per Km, Pune Local Taxi Fare, Pune Outstation Cab Fare, Pune Airport Cab Fare, Pune Drop Taxi Charges, Pune Round Trip Fare, Pune AC Cab Fare, Pune SUV Fare, Pune Cab Rate List, Affordable Cab Fare Pune, Cheap Taxi Fare Pune, Pune Night Cab Charges, Pune Family Trip Cab Fare, Pune Corporate Cab Charges" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punecabfare;